import { cn } from '@/app/lib/utils';
import React from 'react';
import { ScrollContentProps } from '../scrollbar.types';

export function ScrollContent({
  scrollRef,
  externalScrollRef,
  scrollAreaId,
  className,
  maxHeight,
  maxWidth,
  onScroll,
  children,
}: ScrollContentProps) {
  return (
    <div
      ref={(el) => {
        (scrollRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
        if (externalScrollRef) {
          (externalScrollRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
        }
      }}
      className={cn(
        'w-full h-full overflow-auto native-scrollbar-hidden scrollbar-primary',
        maxHeight,
        maxWidth,
        className,
      )}
      id={scrollAreaId}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}
